import gql from 'graphql-tag';

const UPDATE_SALES_CHANNELS = gql`mutation updateSaleChannel ($input: SaleChannelInput) {
    updateSaleChannel (input: $input) {
        internalCode
    }
}`;

export default UPDATE_SALES_CHANNELS;
